/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {TriggerAutomationEvent} from './TriggerAutomationEvent';

/**
 * The InlineResponse20112 model module.
 * @module model/InlineResponse20112
 * @version 1.0.0
 */
export class InlineResponse20112 {
  /**
   * Constructs a new <code>InlineResponse20112</code>.
   * @alias module:model/InlineResponse20112
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse20112</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20112} obj Optional instance to populate.
   * @return {module:model/InlineResponse20112} The populated <code>InlineResponse20112</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20112();
      if (data.hasOwnProperty('data'))
        obj.data = TriggerAutomationEvent.constructFromObject(data['data']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TriggerAutomationEvent} data
 */
InlineResponse20112.prototype.data = undefined;

